export default __webpack_public_path__ + "ed9a565b80a1d7fc073f4ea45f707cfc.svg";